var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "物料信息",
        width: "90%",
        visible: _vm.visible,
        "close-on-click-modal": false,
      },
      on: {
        close: function ($event) {
          return _vm.close()
        },
      },
    },
    [
      _c("div", { staticClass: "el-dialog-div1" }, [
        _c(
          "div",
          { staticClass: "dialog-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "UniformCss",
                staticStyle: { "padding-bottom": "120px" },
                attrs: { "label-width": "120px" },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "物料号" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.orderMaterial.materialCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderMaterial,
                                    "materialCode",
                                    $$v
                                  )
                                },
                                expression: "orderMaterial.materialCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "物料名称" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.orderMaterial.materialName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderMaterial,
                                    "materialName",
                                    $$v
                                  )
                                },
                                expression: "orderMaterial.materialName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "物料类型" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.orderMaterial.materialType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.orderMaterial,
                                      "materialType",
                                      $$v
                                    )
                                  },
                                  expression: "orderMaterial.materialType",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "销售物料", value: "1" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "礼品物料", value: "2" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "宣传物料", value: "3" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "其它", value: "4" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "产品资料", value: "5" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "手册", value: "6" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "物料库存" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.orderMaterial.storage,
                                callback: function ($$v) {
                                  _vm.$set(_vm.orderMaterial, "storage", $$v)
                                },
                                expression: "orderMaterial.storage",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "物料说明" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.orderMaterial.wlsm,
                                callback: function ($$v) {
                                  _vm.$set(_vm.orderMaterial, "wlsm", $$v)
                                },
                                expression: "orderMaterial.wlsm",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "申领单价" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.orderMaterial.price,
                                callback: function ($$v) {
                                  _vm.$set(_vm.orderMaterial, "price", $$v)
                                },
                                expression: "orderMaterial.price",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "申领数量" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.orderMaterial.nums,
                                callback: function ($$v) {
                                  _vm.$set(_vm.orderMaterial, "nums", $$v)
                                },
                                expression: "orderMaterial.nums",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "申领总金额" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.orderMaterial.totalSums,
                                callback: function ($$v) {
                                  _vm.$set(_vm.orderMaterial, "totalSums", $$v)
                                },
                                expression: "orderMaterial.totalSums",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "申领备注" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.orderMaterial.applyRemarks,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderMaterial,
                                    "applyRemarks",
                                    $$v
                                  )
                                },
                                expression: "orderMaterial.applyRemarks",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "审批数量" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.isdetail },
                              model: {
                                value: _vm.orderMaterial.approveNums,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderMaterial,
                                    "approveNums",
                                    $$v
                                  )
                                },
                                expression: "orderMaterial.approveNums",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "审批总金额" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.orderMaterial.approveTotalSums,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderMaterial,
                                    "approveTotalSums",
                                    $$v
                                  )
                                },
                                expression: "orderMaterial.approveTotalSums",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "审批备注" } },
                          [
                            _c("a-textarea", {
                              attrs: { disabled: _vm.isdetail, rows: 3 },
                              model: {
                                value: _vm.orderMaterial.approveRemarks,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderMaterial,
                                    "approveRemarks",
                                    $$v
                                  )
                                },
                                expression: "orderMaterial.approveRemarks",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      [
                        _c("el-form-item", { attrs: { label: "物料图片" } }, [
                          _vm.pictures != null
                            ? _c(
                                "div",
                                _vm._l(_vm.pictures, function (pic, index) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "pic-box" },
                                    [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "150px",
                                          height: "150px",
                                        },
                                        attrs: {
                                          src:
                                            typeof pic === "object"
                                              ? pic.url
                                              : pic,
                                          fit: "contain",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "text-center",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.isdetail
            ? _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("关闭")]
              )
            : _vm._e(),
          !_vm.isdetail
            ? _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v("取消")]
              )
            : _vm._e(),
          !_vm.isdetail
            ? _c(
                "vxe-button",
                {
                  attrs: { status: "success" },
                  on: {
                    click: function ($event) {
                      return _vm.saveMaterial()
                    },
                  },
                },
                [_vm._v("保存")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }